import React from 'react';
export function GuaranteeSection() {
  return <section className="bg-cream py-16 px-4 border-y border-gray-200" data-id="element-97">
      <div className="max-w-3xl mx-auto text-center" data-id="element-98">
        <div className="inline-flex items-center justify-center w-24 h-24 bg-white rounded-full shadow-md mb-8 border-4 border-soft-gold" data-id="element-99">
          <span className="text-5xl" data-id="element-100">🛡️</span>
        </div>

        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-8 leading-tight" data-id="element-101">
          <span className="italic text-soft-gold" data-id="element-102">Risk-Free</span> Guarantee
        </h2>

        <div className="font-sans text-xl md:text-2xl text-gray-800 space-y-4 font-medium max-w-2xl mx-auto" data-id="element-103">
          <p data-id="element-104">Try it for 7 days.</p>
          <p data-id="element-105">If it's not for you, we'll refund 100% of your money.</p>
          <p className="text-orange font-bold pt-4" data-id="element-106">No stress.</p>
          <p className="text-orange font-bold" data-id="element-107">No risk.</p>
          <p className="text-orange font-bold" data-id="element-108">No awkward back-and-forth.</p>
        </div>
      </div>
    </section>;
}